import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowRight, Wrench } from "lucide-react";

export default function TechniquesStep({ techniques, onDone }) {
  return (
    <div>
      <div className="space-y-4">
        {techniques.map((t, i) => (
          <Card key={i} className="rounded-2xl border-[var(--ha-border)] bg-white">
            <CardContent className="p-6">
              <div className="flex items-start gap-3">
                <div className="h-9 w-9 rounded-xl bg-[var(--ha-secondary)]/15 grid place-items-center shrink-0">
                  <Wrench className="w-4 h-4 text-[var(--ha-secondary)]" strokeWidth={1.75} />
                </div>
                <div className="flex-1">
                  <h3 className="font-bold text-[var(--ha-text)]">{t.name}</h3>
                  <ol className="mt-3 space-y-1.5 text-sm text-[var(--ha-muted)] leading-relaxed list-decimal list-inside">
                    {t.steps.map((s, si) => <li key={si}>{s}</li>)}
                  </ol>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
      <div className="mt-8 flex justify-end">
        <Button data-testid="techniques-continue-btn" onClick={onDone} className="rounded-full bg-[var(--ha-primary)] hover:bg-[var(--ha-primary-hover)] text-white h-11 px-6">
          Continuar <ArrowRight className="w-4 h-4 ml-1.5" strokeWidth={1.75} />
        </Button>
      </div>
    </div>
  );
}
